import { Icon, Typography } from '@eventr/common-storybook'
import { windowSizes } from '../../../../state/windowState/windowSignals'

export default function NoConnectionMapsPage() {
    return (
        <div
            style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px',
                    padding: '16px',

                    paddingBottom: `${
                        windowSizes.value.insets.insets.bottom + 70 + 16
                    }px`,
                }}
            >
                <Icon name="Wifi_Off" />

                <Typography variant="bodyBold">No connection</Typography>

                <Typography variant="bodySubtext">
                    Connect to the internet to access the map.
                </Typography>
            </div>
        </div>
    )
}
